import { useState } from "react";
import BottomBar from "./BottomBar";
import NotificationsQueueMainContent from "./NotificationsQueueMainContent";
import TopBar from "./TopBar";
import { useNotifications } from "./useNotifications";
import "./NotificationsQueue.scss";

/**
 * Main notifications queue layout: toolbar (send type + filters + icons), infinite-scroll list panel, and footer actions.
 * Passes the full {@link useNotifications} result as `useNotificationsHookData` to each major child; column filter panel
 * open state stays local to this layout (`columnFiltersExpanded` / `setColumnFiltersExpanded`).
 * @returns {import('react').JSX.Element}
 */
const NotificationsQueue = () => {
    const [columnFiltersExpanded, setColumnFiltersExpanded] = useState(false);

    const useNotificationsHookData = useNotifications();

    return (
        <section
            className="notifications-main-panel"
            aria-label="Notifications queue"
        >
            <div className="notifications-queue notifications-queue--layout">
                <TopBar
                    useNotificationsHookData={useNotificationsHookData}
                    columnFiltersExpanded={columnFiltersExpanded}
                    setColumnFiltersExpanded={setColumnFiltersExpanded}
                />

                <NotificationsQueueMainContent
                    useNotificationsHookData={useNotificationsHookData}
                    columnFiltersExpanded={columnFiltersExpanded}
                />

                <BottomBar useNotificationsHookData={useNotificationsHookData} />
            </div>
        </section>
    );
};

export default NotificationsQueue;
